import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  priceTypeCash: {
    id: 'storeDetails:storeDetails:priceTypeCash',
    defaultMessage: 'Cash Prices',
    description: 'Modal store details cash price type title',
  },
  priceTypeCredit: {
    id: 'storeDetails:storeDetails:priceTypeCredit',
    defaultMessage: 'Credit Prices',
    description: 'Modal store details credit price type title',
  },
});
